import QueryBase from './QueryBase';
import log from 'loglevel';
/**
 * 降级搜索seek
 *
 * @export
 * @class CompatQuerySeek
 * @extends {QueryBase}
 */
export default class CompatQuerySeek extends QueryBase {
  constructor() {
    super();
  }

  async query(start, end) {
    let data = this.dbController.dbData;
    let flipResult = Array.prototype.slice.call(data).filter((item, index) => {
      return item.flipOver === 1 && item.time <= end;
    });

    if (flipResult.length === 0) {
      log.warn(`no such flipOver data, start: ${start}, end: ${end}`);
      return [];
    }

    log.info(`一共找到了${flipResult.length}条翻页消息`);
    log.info(`一共找到了${flipResult.length}条翻页消息`);
    // 拿到最后一条翻页的文档hash 和 currentPage
    let flipData = flipResult.pop();
    let fileHash = flipData.hash;
    let fileCurrentPage = flipData.currentPage;
    let flipTime = flipData.time;
    log.info(
      `基于${start}找到该文档最后一条翻页消息，文档hash:${fileHash} , page:${fileCurrentPage}, time:${flipTime}`
    );

    log.info(
      `现在要找到数据时间介于${flipTime}--${end}, 文档hash:${fileHash}, 页码：${fileCurrentPage}, cid:${flipData.cid}, flipOver:0, uid>0`
    );

    let afterFlipResult = Array.prototype.slice.call(data).filter((item, index) => {
      return (
        item.time >= flipTime &&
        item.time <= end &&
        item.hash === fileHash &&
        item.currentPage === fileCurrentPage &&
        item.cid === flipData.cid &&
        item.flipOver === 0
      );
    });

    // 把翻页添加进去
    afterFlipResult.unshift(flipData);

    log.info(
      `基于time: ${flipTime}-${end}, 共查询出${afterFlipResult.length}条数据，翻页距离结束共有${end - flipTime}s.`
    );

    return afterFlipResult || [];
  }
}
